export default "__VITE_ASSET__6db6355e__"